import { useState } from 'react'
import { pictures } from './NumbersPictures';
import numbs from '../../../res/numbs.png';
import '../MemoryGames.css';
import Sidebar from '../../Sidebar/Sidebar';

function InitialCard({ picture, isRevealed, revealCard }) {
  const firstCard = isRevealed ? picture : { src:numbs, alt: 'Carte représentant un dièse' }
    
    return (
      <div className='initialCard' onClick={() => revealCard()}>
        <img className='initialCard'src={firstCard.src} alt={firstCard.alt}/>
      </div>
    );
}
  
export default function MemoryNumbers() {
    const cards = pictures.map((picture) => ({picture, isRevealed: false}))
    const pairedCards = cards.concat(cards)
    const randomCards = pairedCards.sort(() => Math.random() - 0.5)
    const [ cardsInitialState, setCardsInitialState] = useState(randomCards)
    const [ selectedCards, setSelectedCards ] = useState([])
    const [ blockedCard, setBlockedcard ] = useState(false)
  
    function revealCard(index) {
      if (blockedCard) {
        return
      }
  
      if (selectedCards.length === 0) {
        setSelectedCards([index])
      } else {
        if (selectedCards[0] === index) {
          return
        } else if (cardsInitialState[selectedCards[0]].picture.src === cardsInitialState[index].picture.src) {
          const nextCardsState = cardsInitialState.map(card => ({...card}))
  
          nextCardsState[index].isRevealed = true
          nextCardsState[selectedCards[0]].isRevealed = true
          
          setCardsInitialState(nextCardsState)
          setSelectedCards([])
        } else {
          setSelectedCards([selectedCards[0], index])
          setBlockedcard(true)
  
          const blockedTime = setInterval(() => {
            setSelectedCards([])
            setBlockedcard(false)
            clearInterval(blockedTime)          
          }, 700)
        }
      }
    }
  
    function Reset() {
      setCardsInitialState(randomCards);
      setSelectedCards ([]);
      setBlockedcard(false);
    }
  
    return (
      <section className='memory_global_section'>
        <div className='memory_main_section'>
          <h2 className="memory_game_title"> Memory</h2>
          <h3 className="memory_game_subtitle">Chiffres</h3>
          <p className='memory_game_rule '>Retrouve les paires dissimulées derrière les cartes.</p>
          <div className='cards'>
          {cardsInitialState.map((cards, index) => {
            return (
              <InitialCard 
                value={index} 
                picture={cards.picture} 
                isRevealed={cards.isRevealed || selectedCards.includes(index)}
                revealCard={() => revealCard(index)}
              />
            )
          })}      
          </div>
          <button className='memory_reset' onClick ={() => Reset()}>Recommencer</button>
        </div>
        <div>
          <Sidebar/>
        </div>
      </section>
    );
}
  
  